import { Component } from "@angular/core";
import {
  NgbCarouselConfig,
  NgbCarouselModule,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-slider",
  standalone: true,
  imports: [NgbCarouselModule],
  templateUrl: "./slider.component.html",
  styleUrl: "./slider.component.scss",
})
export class SliderComponent {
  constructor(private sliderConfig: NgbCarouselConfig) {
    this.sliderConfig.showNavigationArrows = false;
    this.sliderConfig.showNavigationIndicators = false;
    this.sliderConfig.interval = 5000;
  }

  path = "assets/images/slider/onboarding";
  images = [
    `${this.path}_old.png`,
    `${this.path}2_old.png`,
    `${this.path}3_old.png`,
  ];
}
